export const OPEN_OUTPUT_WINDOW = 'output/OPEN_OUTPUT_WINDOW';
export const CLOSE_OUTPUT_WINDOW = 'output/CLOSE_OUTPUT_WINDOW';
export const CLOSE_ALL_OUTPUT_WINDOWS = 'output/CLOSE_ALL_WINDOWS';
export const UPDATE_DISPLAY_SIZE = 'output/UPDATE_DISPLAY_SIZE';
export const SET_BLOCK_ADDRESS = 'output/SET_BLOCK_ADDRESS';
export const TOGGLE_FADE_TO_BLACK = 'output/TOGGLE_FADE_TO_BLACK';

export const RENDERABLE_STATE_BROADCAST = 'output/RENDERABLE_STATE';
export const WINDOW_HAS_CLOSED = 'output/WINDOW_HAS_CLOSED';
